import React from "react";
import axios from "axios";
import REACT_APP from "../../environment";
import { Button, Modal } from "antd";
import { Field, Form, Formik } from "formik";
import { AntInput } from "../../hooks/createAntDFields";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { endWait, startWait } from "../../store/waiting";
import { userUpdateValidation, userUpdateInitialValue } from "../../constants/user";
import { useTranslation } from "react-i18next";

const UpdateUser = ({ user, isModalOpen, setIsModalOpen, getData }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const validate = userUpdateValidation(t);

    const cancel = (resetForm) => {
        if (typeof resetForm === "function") resetForm();
        setIsModalOpen(false);
    };

    const submit = async (data, { setSubmitting, resetForm }) => {
        dispatch(startWait());
        const body = { ...data };
        delete body.email;
        delete body.username;
        await axios
            .put(`${REACT_APP.API_URL}/api/hrp/provider/v1/user`, body, { headers: { Authorization: sessionStorage.getItem("token") } })
            .then(() => {
                resetForm();
                toast.success(t("Updated!"));
                getData();
                setIsModalOpen(false);
            })
            .catch((err) => {
                console.log(err);
                toast.error(t((err.response?.data?.errors && err.response.data.errors[0]?.message) || err.message));
            });
        setSubmitting(false);
        dispatch(endWait());
    };

    return (
        <>
            <Formik initialValues={user || userUpdateInitialValue} enableReinitialize validationSchema={validate} onSubmit={submit}>
                {({ isSubmitting, submitCount, errors, resetForm }) => (
                    <Modal title={t("Update user")} open={isModalOpen} footer={[]} onCancel={() => cancel(resetForm)}>
                        <div className="pt-4">
                            <Form autoComplete="off">
                                <div>
                                    <label htmlFor="first_name">{t("First name")}</label>
                                    <Field component={AntInput} submitCount={submitCount} size="large" name="first_name" />
                                    <label htmlFor="last_name">{t("Last name")}</label>
                                    <Field component={AntInput} submitCount={submitCount} size="large" name="last_name" />
                                </div>
                                <div className="ant-modal-footer">
                                    <Button onClick={() => cancel(resetForm)}>{t("Cancel")}</Button>
                                    <Button type="primary" htmlType="submit">
                                        {t("Submit")}
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </Modal>
                )}
            </Formik>
        </>
    );
};
export default UpdateUser;
